import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCategoryEditQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetCategoryEditQuery = { __typename?: 'Query', getCategoryById?: { __typename?: 'Category', id: string, name: string } | null };


export const GetCategoryEditDocument = gql`
    query getCategoryEdit($id: ID!) {
  getCategoryById(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetCategoryEditQuery__
 *
 * To run a query within a React component, call `useGetCategoryEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCategoryEditQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryEditQuery, GetCategoryEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryEditQuery, GetCategoryEditQueryVariables>(GetCategoryEditDocument, options);
      }
export function useGetCategoryEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryEditQuery, GetCategoryEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryEditQuery, GetCategoryEditQueryVariables>(GetCategoryEditDocument, options);
        }
export type GetCategoryEditQueryHookResult = ReturnType<typeof useGetCategoryEditQuery>;
export type GetCategoryEditLazyQueryHookResult = ReturnType<typeof useGetCategoryEditLazyQuery>;
export type GetCategoryEditQueryResult = Apollo.QueryResult<GetCategoryEditQuery, GetCategoryEditQueryVariables>;